import React, { useState } from 'react';
import { useLocation } from 'react-router-dom';
import Header from './Header';
import HeaderActivityStrip from './HeaderActivityStrip';
import Sidebar from './Sidebar';

// Routes that manage their own height, padding, and scroll.
// Full-bleed pages get `overflow-hidden` on main instead of `overflow-y-auto`.
const FULL_BLEED_PATHS = new Set(['/', '/graph']);

interface LayoutProps {
  children: React.ReactNode;
}

const Layout: React.FC<LayoutProps> = ({ children }) => {
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const location = useLocation();
  const fullBleed = FULL_BLEED_PATHS.has(location.pathname);

  return (
    <div className="h-screen overflow-hidden flex flex-col w-full">
      {/* Full-width header */}
      <Header onMenuClick={() => setSidebarOpen(!sidebarOpen)} />

      {/* Activity strip — silver hairline at idle, colored flow while an
          LLM query is in flight (subscribes to ChatActivityContext). */}
      <HeaderActivityStrip />

      {/* Content area with sidebar and main */}
      <div className="flex flex-1 overflow-hidden">
        <Sidebar isOpen={sidebarOpen} onClose={() => setSidebarOpen(false)} />

        {/* Page content — full-bleed pages handle their own scroll */}
        {fullBleed ? (
          <main className="flex-1 overflow-hidden relative">
            {children}
          </main>
        ) : (
          <main className="flex-1 overflow-y-auto relative">
            <div className="px-4 pt-10 pb-5 md:px-8 md:pt-10 md:pb-6 lg:px-12">
              <div className="max-w-6xl mx-auto">
                {children}
              </div>
            </div>
          </main>
        )}
      </div>
    </div>
  );
};

export default Layout;
